import React, { useEffect, useState } from 'react';
import { Bar } from '@ant-design/plots';

const BarChart = ({ data, xField, yField, color, xAxisLabel, yAxisLabel }) => {

  const [chartColor, setChartColor] = useState([]);

  useEffect(() => {
    loadData();
  }, [])

  const loadData = () => {
    if (color === "raceBar") {
      setChartColor(["#2193AE", "#32669E", "#4945A8", "#724DAD", "#67e67d", "#ff74c2", "#7ca6b4", "#4e4e4e"])
    } else if (color === 'reasonBar') {
      setChartColor([
        "#32669E",
        "#3a77b0",
        "#4488c2",
        "#4d95ce",
        "#60a4d4",
        "#77b3db",
        "#99c9e6",
      ]);
    } else if (color === 'ageBar') {
      setChartColor (['#32669E'])
    }
  }

  const config = {
    data,
    scale: {
      color: {
        range: chartColor
      },
    },
    xField: 'type',
    yField: 'value',
    colorField: 'type',
    legend: false,
    label: {
      text: 'value',
      style: {
        fontWeight: 'bold',
        // maxWidth: 50
      },
      //  transform: [{ type: 'contrastReverse' }],
       position: 'inside',
    },
    axis: {
      x: {
        title: xAxisLabel,
        style: {
          titleFill: 'black'
        }
      },
      y: {
        title: yAxisLabel,
        style: {
          titleFill: 'black'
        }
      }
    },
    tooltip: {
      items: [
        {
          channel: "color",
          name:xAxisLabel,
          valueFormatter: (val) => `${val}`,
        },
        {
          channel: "y",
          name:'Number:',
          valueFormatter: (val) => `${val}`,
        },
       ],
     },
     style: {
      maxWidth: 50,
    },
  };

  return <Bar {...config} />

};

export default BarChart;